import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import Currency from "components/Currency";
import SchoolLogo from "components/school_money/SchoolLogo";
import CardHolderName from "components/school_money/basket/checkout/secure_trading/CardHolderName";
import CardDetails from "components/school_money/basket/checkout/secure_trading/CardDetails";
import Checkout from "state/school_money/entities/Checkout";
import PaymentSuccess from "components/school_money/basket/checkout/PaymentSuccess";
import PaymentStatus from "components/school_money/basket/checkout/PaymentStatus";
import PaymentTypeSelector from "components/school_money/basket/checkout/secure_trading/PaymentTypeSelector";
import trustPaymentsLogo from "components/assets/images/school_money/secure_trading/trust_payments.png";
import schoolMoneyLogo from "components/assets/images/school_money/school_money-logo--text-right.svg";
import { getUserIdentity } from "state/app/selectors";
import { getSchoolByID, getCheckoutTotalToPay, getSecureTradingCardPayJWTString, getCheckoutStatus, getSecureTradingWalletPayJWTString } from "state/school_money/selectors";
import "./PSD2PaymentForm.css";

class PSD2PaymentForm extends React.Component {

  static propTypes = {
    schoolID: PropTypes.string.isRequired
  }

  getPaymentComponent() {

    const {walletPayJWTString, status, userIdentity} = this.props;
    const isCardPayJWTSet = this.props.cardPayJWTString !== undefined;

    if(status === Checkout.status.PREPARING) {return null;}

    if (walletPayJWTString !== undefined) {
      if (userIdentity.get("platform") === "iphone") {
        return <PaymentTypeSelector walletType="apple" walletJWTString={walletPayJWTString}/>;
      } else{
        return <PaymentTypeSelector walletType="google" walletJWTString={walletPayJWTString}/>;
      }
    }

    if (isCardPayJWTSet) {
      return <CardDetails/>;
    }
    return <CardHolderName/>;
  }

  render() {

    const testMode = process.env.REACT_APP_SECURE_TRADING_PAYMENT_MODE === "TEST";
    const {applePayJWTString, status} = this.props;

    return (
      <div className="checkout-payment">
        <div className="checkout-payment__wrapper">
          <div className="checkout-payment__school-money-logo-container">
            <img className="checkout-payment__school-money-logo" src={schoolMoneyLogo} alt="School Money" />
          </div>
          { applePayJWTString === undefined ? <PaymentStatus/> : null }
          <div className="checkout-payment__header">
            <div className="checkout-payment__total-to-pay">
              <div className="checkout-payment__total-to-pay-label">Total To Pay</div>
              <div className="checkout-payment__total-to-pay-amount">
                <Currency amount={ this.props.totalToPay } />
              </div>
            </div>
            <div className="checkout-payment__school">
              <SchoolLogo className="checkout-payment" school={ this.props.school } />
            </div>
          </div>
          {status === Checkout.status.COMPLETED ? <PaymentSuccess schoolID={this.props.schoolID}/> : this.getPaymentComponent()}
          <div className="checkout-payment__footer">
            Powered by <img className="checkout-payment__secure-trading-logo" src={trustPaymentsLogo} alt="Secure Trading" />
          </div>
          { testMode ? <div className="checkout-payment__environment-indicator">TEST environment</div> : "" }
        </div>
      </div>
    );
  }
}

export default connect(
  (state, {schoolID}) => ({
    status: getCheckoutStatus(state),
    school: getSchoolByID(state, schoolID),
    totalToPay: getCheckoutTotalToPay(state),
    cardPayJWTString: getSecureTradingCardPayJWTString(state),
    walletPayJWTString: getSecureTradingWalletPayJWTString(state),
    userIdentity: getUserIdentity(state)
  }),
  undefined
)(PSD2PaymentForm);



// WEBPACK FOOTER //
// ./src/components/school_money/basket/checkout/secure_trading/PSD2PaymentForm.js